var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0195312,
    y: 0.664062,
    width: 25.7502,
    height: 25.7502,
    rx: 12.8751,
    fill: "#F9CF66"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_56434)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2679_56434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4527 8.40081C16.4006 8.8719 17.0521 9.8501 17.0521 10.9805C17.0521 12.1108 16.4006 13.089 15.4527 13.5601M16.7322 16.9087C17.6991 17.3462 18.5699 18.0594 19.2912 18.9774M6.49609 18.9774C7.74137 17.3925 9.43205 16.4184 11.2943 16.4184C13.1565 16.4184 14.8472 17.3925 16.0924 18.9774M14.1732 10.9805C14.1732 12.5704 12.8842 13.8594 11.2943 13.8594C9.70429 13.8594 8.41536 12.5704 8.41536 10.9805C8.41536 9.39049 9.70429 8.10156 11.2943 8.10156C12.8842 8.10156 14.1732 9.39049 14.1732 10.9805Z",
    stroke: "#FFFBE5",
    strokeWidth: 1.2262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_56434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7144,
    height: 14.7144,
    fill: "white",
    transform: "translate(5.53906 6.17969)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2679_56434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.3541,
    height: 15.3541,
    fill: "white",
    transform: "translate(5.21875 6.17969)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.fc4c6fcf5278bf2e9cca9afb345761e7.svg";
export { ForwardRef as ReactComponent };